var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentosDigitais(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      marginLeft: 2,
      marginTop: 1
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#F1F1F3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.387 12.3509L13.111 14.9222C13.1034 14.9927 13.1696 15.0485 13.2378 15.029L15.4522 14.3977L19.5802 8.19425C19.8671 7.76305 19.9359 7.22249 19.7661 6.73319L19.7036 6.55311C19.572 6.174 19.2697 5.87892 18.8875 5.75658C18.3448 5.58283 17.7526 5.79025 17.4369 6.26472L13.387 12.3509Z",
    stroke: "#F1F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.127C16.2918 14.1483 16.1486 14.022 16.1486 14.022",
    stroke: "#F1F1F3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H13V17H5V15ZM5 11H13V13H5V11ZM11 1H3C1.9 1 1 1.9 1 3V19C1 20.1 1.89 21 2.99 21H15C16.1 21 17 20.1 17 19V7L11 1ZM15 19H3V3H10V8H15V19Z",
    fill: "#F1F1F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F1F1F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentosDigitais);
export default __webpack_public_path__ + "static/media/documentosDigitais.f6b5b719688b00e4b439bb4d5bcf113a.svg";
export { ForwardRef as ReactComponent };